import React from 'react';

import './Benefits.scss';

function Benefits() {
  return (
    <div className="mn_nagBenefits">
      <h3>Benefits of being a member</h3>
      <ul>
        <li>
          <h4>Stack miles</h4>
          <p>Earn additional miles by shopping with your MileagePlus credit card.</p>
        </li>
        <li>
          <h4>Earn bonus miles</h4>
          <p>Take advantage of special bonus mile shopping events.</p>
        </li>
        <li>
          <h4>Extra miles at your favorite stores</h4>
          <p>Select your favorite stores and we'll email you when they offer extra miles.</p>
        </li>
      </ul>
    </div>
  );
}

export default Benefits;
